<template>
  <ul class="p-0 m-2">
    <li v-for="(item, index) in modelValue" :key="index" class="mt-2">
      <div class="d-flex">
        <span>
          <vs-switch color="success" v-model="item.value" vs-icon="done" :disabled="!status"
            @change="onSwitchChange(item)" />
        </span>
        <span class="ms-2">{{ item.title }}</span>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'switchListArea',
  props: {
    modelValue: {
      type: Array,
      required: true
    },
    status: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'reloadList', 'formatList'],
  methods: {
    onSwitchChange(item) {
      this.$emit('update:modelValue', this.modelValue);
      if (item.filter) {
        this.$emit('formatList');
      } else {
        this.$emit('reloadList');
      }
    }
  }
};
</script>
